"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.USERS_AND_TEAMS_ONBOARDING = exports.USER_APP_ATTRIBUTE = exports.EMAIL = exports.VALUE = exports.KEY = exports.USER_ID = exports.ID = void 0;

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var ID = 'id';
exports.ID = ID;
var USER_ID = 'userId';
exports.USER_ID = USER_ID;
var KEY = 'key';
exports.KEY = KEY;
var VALUE = 'value';
exports.VALUE = VALUE;
var EMAIL = 'email';
exports.EMAIL = EMAIL;
var USER_APP_ATTRIBUTE = 'UserAppAttribute'; // attribute keys

exports.USER_APP_ATTRIBUTE = USER_APP_ATTRIBUTE;

var USERS_AND_TEAMS_ONBOARDING = "onboarding:settings-ui:users-and-teams:" + _hubspot.default.get();

exports.USERS_AND_TEAMS_ONBOARDING = USERS_AND_TEAMS_ONBOARDING;